import { useState } from 'react'
import handwritingImages from './wordmark-images.json'

export default function ShopWordmark() {
  // One independent pick per page load. Cart updates and hovering leave
  // the chosen handwriting in place; there is no persisted first choice.
  const [source] = useState(() => handwritingImages[Math.floor(Math.random() * handwritingImages.length)])
  const filename = `alexandria-logo-${source.slice(source.lastIndexOf('/') + 1)}`
  const assets = (globalThis as unknown as { __SHOP_MODELS__?: Record<string, string> }).__SHOP_MODELS__

  return (
    // eslint-disable-next-line @next/next/no-html-link-for-pages -- Shopify needs a full page reset; this bundle has no Next router.
    <a href="/" className="shop-wordmark pointer-events-auto" aria-label="Alexandria — shop home">
      <img src={assets?.[filename] ?? source} alt="" draggable={false}
        width={180} height={36} fetchPriority="high" />
    </a>
  )
}
